import { getTerminateSession } from '@stadionhq-v3/stream-api';
import { clearStreamSession } from '@stadionhq-v3/stream-ui';
import { signIn, signOut } from 'next-auth/react';

const memoizeAsync = (fn: Function) => {
  const cache = new Map();

  return async (...args: string[]) => {
    const key = JSON.stringify(args);
    if (cache.has(key)) {
      return cache.get(key);
    }

    const result = await fn(...args);
    cache.set(key, result);
    return result;
  };
};

export const forceSignOut = memoizeAsync(async (token?: string) => {
  await signOut({
    redirect: false,
  });

  clearStreamSession();

  if (token) {
    await getTerminateSession({ apijwttoken: token });
  }

  // Redirect to sign in page
  signIn('default', {
    callbackUrl: `${window.location.href}/`,
  });
});
